// campaigns.service.ts
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiCampaign, Campaign } from '../../types/campaigns.models';
import {
  CREZCO_DONATION_APP_CONFIG,
  CrezcoDonationAppRuntimeConfig,
} from 'src/app/app.config';

export const adaptCampaign = (c: ApiCampaign): Campaign => {
  return {
    id: c.id,
    productId: c.productId,
    productFeeId: c.productFeeId,
    nameEn: c.nameEn,
    nameEs: c.nameEs,
    isActive: c.isActive,
    isPopup: c.isPopup,
    descriptionEn: c.descriptionEn,
    descriptionEs: c.descriptionEs,
    currentAmount: c.currentAmount,
    targetAmount: c.targetAmount * 100,
    isFeatured: c.isFeatured,
    isIndefinite: c.isIndefinite,
    startDate: c.startDate ? new Date(c.startDate) : null,
    endDate: c.endDate ? new Date(c.endDate) : null,
    imageUrl: c.imageUrl,
    status: c.status,
    lastUpdatedAt: new Date(c.lastUpdatedAt),
    createdAt: new Date(c.createdAt),
  };
};

@Injectable({ providedIn: 'root' })
export class CampaignsService {
  constructor(
    private http: HttpClient,
    @Inject(CREZCO_DONATION_APP_CONFIG)
    private config: CrezcoDonationAppRuntimeConfig
  ) {}

  private get campaignEndpoint(): string {
    return `${this.config.apiBaseUrl}/Campaigns`;
  }

  getAll(): Observable<Campaign[]> {
    return this.http.get<ApiCampaign[]>(this.campaignEndpoint).pipe(
      map(
        (list) =>
          list
            .filter((c) => c.isActive) // sólo activas
            .map(adaptCampaign) // adaptar
            .sort(this.sortFeaturedAndUpdatedDesc) // ordenar
      )
    );
  }

  private sortFeaturedAndUpdatedDesc(a: Campaign, b: Campaign): number {
    // 1) destacadas primero
    if (a.isFeatured !== b.isFeatured) return a.isFeatured ? -1 : 1;
    // 2) dentro del grupo, lastUpdatedAt desc (más reciente primero)
    return b.lastUpdatedAt.getTime() - a.lastUpdatedAt.getTime();
  }
}
